import HelpContainer from 'components/help/HelpContainer';
import HelpInstruction from 'components/help/HelpInstruction';
import HelpSection from 'components/help/HelpSection';
import HelpTable from 'components/help/HelpTable';
import DownloadPdf from 'components/icons/DownloadPdf';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { AddIcon } from 'components/UI/dialogs/HelpDialogStyled';

const HelpDialog = () => {
    const overviewList = [
        'View all registered equipment across locations',
        'Search and filter by equipment number, category, type, or organization',
        'Edit or remove equipment records',
        'Manage equipment metadata (e.g., VIN, License Plate, Type, Organization)',
    ];

    const controls = [
        {
            action: 'Add new',
            icon: <AddIcon />,
            description: 'Create a new equipment record in the master list.',
        },
        {
            action: 'Modify record',
            icon: <MoreVertIcon />,
            description: (
                <span>
                    Edit or remove the equipment details (Equipment #, Category, VIN, etc.).
                    <br />
                    <br />
                    Note: Changes made here will also reflect on any associated Authorized Equipment records at relevant locations. Please review
                    alerts and access if edits involve critical fields like Equipment Number.
                </span>
            ),
        },
        {
            action: 'Download options',
            icon: <DownloadPdf />,
            description: 'Export the current list of equipment in the preferred file format.',
        },
    ];

    const instructions = [
        {
            title: 'Add New Equipment',
            steps: [
                <>
                    <span>Click on the</span>
                    <span>
                        <AddIcon />
                    </span>
                    <span>button in the top-right corner.</span>
                </>,
                'Fill in required details (e.g., Equipment #, Type, Org, etc.).',
                'Click Save to finalize the new record.',
            ],
        },
        {
            title: 'Edit Equipment',
            steps: [
                <span key="edit-step-1" style={{ display: 'inline-block' }}>
                    Click on the
                    <MoreVertIcon style={{ verticalAlign: 'middle' }} />
                    menu next to the equipment you want to edit.
                </span>,
                'Select Edit and update the fields as needed.',
                'Click Save to confirm changes.',
            ],
        },
    ];

    return (
        <HelpContainer
            width="52rem"
            overview={
                <span>
                    The Client Equipment page displays all equipment created in the system across all facilities. This list serves as the master
                    database and source of truth, helping users manage and audit equipment records regardless of location-based access or
                    restrictions.
                    <br />
                    <br />
                    You can:
                </span>
            }
            overviewList={overviewList}
        >
            <HelpSection title="CONTROLS" hasTopDivider={true}>
                <HelpTable rows={controls} />
            </HelpSection>
            <HelpSection
                title="RELATIONSHIP TO AUTHORIZED EQUIPMENT"
                description="Client Equipment records act as the source for location-specific Authorized Equipment lists. Once an IN transaction is submitted, a new equipment record is generated here and optionally linked to the appropriate location."
                hasTopDivider={true}
            />
            <HelpSection title="INSTRUCTIONS" hasTopDivider={true}>
                <HelpInstruction instructions={instructions} height={'13rem'} />
            </HelpSection>
        </HelpContainer>
    );
};

export default HelpDialog;
